import { ItiString } from '../utils/iti-string';

export class ItiTokenService {

    protected tokenName = 'token';

    public hasToken() {
      return !ItiString.IsNullOrWhiteSpace(this.getToken());
    }

    public setToken(token: string) {
      window.localStorage.setItem(this.tokenName, token);
    }

    public getToken() {
      return window.localStorage.getItem(this.tokenName);
    }

    public clearToken() {
      window.localStorage.removeItem(this.tokenName);
    }

    public getDecodedToken(): any {
      try {
        return this.hasToken() ? JSON.parse(atob((this.getToken() as string).split('.')[1])) : null;
      } catch (error) {
        //console.log('Unable to decode token', error);
      }
    }
}

export const itiTokenService = new ItiTokenService();
